import { createSlice } from '@reduxjs/toolkit';

const spaSlice = createSlice({
    name: 'spa',
    initialState: {
        conCheckItems: {
            typeArr: [],
            tagArr: []
        }
    },
    reducers: {
        setConditionBar: (state, action) => {
            state.conCheckItems = action.payload;
        },
        resetConditionBar: (state) => {
            state.conCheckItems = {
                typeArr: [],
                tagArr: []
            };
        }
    },
});

export const { setConditionBar, resetConditionBar } = spaSlice.actions;
export const selectConCheckItems = (state) => state.spa.conCheckItems;
export default spaSlice.reducer;